import Image from 'next/image';
import PropTypes from 'prop-types';
import React from 'react';
import styled from '@emotion/styled';
import { EGROWTHBOOK_FEATURES_FLAGS } from '../../utils/growthbook-constants';
import CopyIcon from '../../public/images/copy-icon.svg';
import { TOAST, toast } from '../../utils/toastify';

const StyledCopyIcon = styled(CopyIcon)`
  width: ${({ theme }) => theme.modularScale.eighteen};
  height: ${({ theme }) => theme.modularScale.eighteen};
  margin: auto;
`;

const PaidPromoContainer = styled.div`
  padding: ${({ theme }) => theme.modularScale.eight};
  background-color: #f4f7ff;
  display: flex;
  flex-direction: column;
  gap: 0.4375rem;
  align-items: center;
`;

const CodeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.modularScale.five};
`;

const LabelText = styled.div`
  color: ${({ theme }) => theme.color.bluePrimary};
  text-align: center;
  font-family: ${({ theme }) => theme.font.sans};
  font-size: ${({ theme }) => theme.modularScale.fourteen};
  font-style: normal;
  font-weight: 400;
  line-height: ${({ theme }) => theme.modularScale.sixteen};
`;

const CodeWrapper = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.modularScale.six};
  padding: ${({ theme }) => theme.modularScale.two} ${({ theme }) => theme.modularScale.sixteen};
  border-radius: ${({ theme }) => theme.modularScale.two};
  border: ${({ theme }) => theme.modularScale.one} solid #c4cde8;
`;

const CodeText = styled.div`
  color: ${({ theme }) => theme.color.bluePrimary};
  text-align: center;
  /* v2/Desktop/H3 */
  font-family: ${({ theme }) => theme.font.heading};
  font-size: ${({ theme }) => theme.modularScale.twentyFour};
  font-style: normal;
  font-weight: 300;
  line-height: ${({ theme }) => theme.modularScale.thirtyTwo};
`;

const PdpPromoBanner = (props) => {
  const { growthbookFeatureFlagValues } = props;
  const {
    [EGROWTHBOOK_FEATURES_FLAGS.PROMO_CODE]: promoCodeValue,
    [EGROWTHBOOK_FEATURES_FLAGS.PROMO_TEXT]: promoTextValue,
  } = growthbookFeatureFlagValues;

  const handleClick = () => {
    if (global?.window?.navigator?.clipboard) {
      global.window.navigator.clipboard.writeText(promoCodeValue);
    }
    toast(`${promoCodeValue} has been copied to clipboard`, { type: TOAST.TYPE.SUCCESS, autoClose: 2000 });
  };

  return (
    <PaidPromoContainer onClick={handleClick} role="presentation">
      <CodeContainer>
        <LabelText>Use code</LabelText>
        <CodeWrapper>
          <CodeText>{promoCodeValue}</CodeText>
          <StyledCopyIcon />
        </CodeWrapper>
      </CodeContainer>
      <LabelText>{promoTextValue}</LabelText>
    </PaidPromoContainer>
  )
}

PdpPromoBanner.defaultProps = {
  growthbookFeatureFlagValues: {},
};

PdpPromoBanner.propTypes = {
  growthbookFeatureFlagValues: PropTypes.object,
};

export default PdpPromoBanner;
